import { html } from '@microsoft/fast-element';

export const sideBarTemplate = html`
    <template role="navigation">
        <slot></slot>
    </template>
`;
